import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SpaceType } from '@/constants/space';
import { TodayAvailabilityModal } from '@/components/elements/TodayAvailabilityModal';
import { SPACE_TYPE } from '@/constants/space';
import { useDialog } from '@/hooks/useDialog';
import { useSuiteLoungeFlow } from '@/hooks/useSuiteLoungeFlow';

export const TodayAvailability = () => {
  const { t } = useTranslation();
  const { dialogRef, open, close } = useDialog();
  const { isSuiteLoungeFlow } = useSuiteLoungeFlow();
  const [currentSpaceType, setCurrentSpaceType] = useState<SpaceType | null>(
    null,
  );

  const handleOpen = useCallback(
    (spaceType: SpaceType) => {
      setCurrentSpaceType(spaceType);
      open();
    },
    [open],
  );

  const handleShowerRoomClick = useCallback(() => {
    handleOpen(SPACE_TYPE.SHOWER_ROOM);
  }, [handleOpen]);

  const handlePrivateRoomClick = useCallback(() => {
    handleOpen(SPACE_TYPE.PRIVATE_ROOM);
  }, [handleOpen]);

  const handleCloseModal = useCallback(() => {
    close();
    setCurrentSpaceType(null);
  }, [close]);

  return (
    <>
      <section className="l-card">
        <h2 className="l-card__title">{t('todayAvailability.title')}</h2>
        <p className="l-vacancy__note">{t('todayAvailability.note')}</p>
        <div className="l-card__body">
          <div
            className={`l-vacancy${!isSuiteLoungeFlow ? ' l-vacancy--single' : ''}`}
          >
            <button
              type="button"
              className="l-vacancy__item l-vacancy__item--shower"
              onClick={handleShowerRoomClick}
            >
              <img
                src="/Common_Icon_Service_Shower.png"
                alt={t('common.altText.showerRoom')}
                className="l-vacancy__icon"
              />
            </button>
            {isSuiteLoungeFlow && (
              <button
                type="button"
                className="l-vacancy__item l-vacancy__item--booth"
                onClick={handlePrivateRoomClick}
              >
                <img
                  src="/Common_Icon_Service_Booth.png"
                  alt={t('common.altText.privateRoom')}
                  className="l-vacancy__icon"
                />
              </button>
            )}
          </div>
        </div>
      </section>

      <TodayAvailabilityModal
        dialogRef={dialogRef}
        onClose={handleCloseModal}
        spaceType={currentSpaceType}
      />
    </>
  );
};
